'use es6';

import { createAction } from 'flux-actions';
import { CLEAR_ATTACHMENTS } from '../constants/fileUploadsActionTypes';
export const clearAttachments = createAction(CLEAR_ATTACHMENTS, threadId => ({
  threadId
}));